export default "__VITE_ASSET__C20rR9ZM__"